import Icon from "@ant-design/icons";

const ProfileSvg = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="icon/profile">
        <path id="Vector" d="M19 20C19 10.5185 5 10.5185 5 20M16.375 8.44444C16.375 10.899 14.4162 12.8889 12 12.8889C9.58375 12.8889 7.625 10.899 7.625 8.44444C7.625 5.98985 9.58375 4 12 4C14.4162 4 16.375 5.98985 16.375 8.44444Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
export const ProfileIcon = (props: any) => <Icon component={ProfileSvg} {...props} />;